module.exports = __webpack_public_path__ + "static/media/bur-jurman-center.56d30035.jpeg";